import { render } from "./CircleBackground.vue?vue&type=template&id=ce986b2c&scoped=true"
import script from "./CircleBackground.vue?vue&type=script&lang=js"
export * from "./CircleBackground.vue?vue&type=script&lang=js"

import "./CircleBackground.vue?vue&type=style&index=0&id=ce986b2c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce986b2c"]])

export default __exports__